var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71473 13.7319L1.17691 14.2546L1.71473 13.7319C1.58124 13.5945 1.50535 13.4113 1.50263 13.2198L1.4072 6.51122C1.40437 6.31244 1.48058 6.12067 1.61908 5.97805L6.10084 1.3631C6.24473 1.21493 6.44334 1.13266 6.64986 1.13569L13.0822 1.22987C13.281 1.23278 13.4705 1.31449 13.609 1.45705L18.2852 6.26821L18.8231 5.74548L18.2852 6.26821C18.4187 6.40555 18.4946 6.58877 18.4973 6.78028L18.5928 13.4888C18.5956 13.6876 18.5194 13.8794 18.3809 14.022L13.8991 18.637C13.7552 18.7851 13.5566 18.8674 13.3501 18.8644L6.91776 18.7702C6.71898 18.7673 6.52949 18.6856 6.39093 18.543L1.71473 13.7319Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagon);
export default __webpack_public_path__ + "static/media/octagon.3a7855c0a74faee3d7102f6d642ba12a.svg";
export { ForwardRef as ReactComponent };